import React from 'react';
import OptionSelect, { IOption } from './OptionSelect';
import BoxesIcon from '../../icons/IconLib/BoxesIcon';

export const OCCUPANCY = {
    ALL: 0,
    NOT_EMPTY: 1,
    ONLY_EMPTY: 2,
    WAITING_LOCATION: 3,
} as const;

export type OccupancyValue = typeof OCCUPANCY[keyof typeof OCCUPANCY];

const OCCUPANCY_OPTIONS: IOption[] = [
    { value: OCCUPANCY.ALL, label: 'הכל' },
    { value: OCCUPANCY.NOT_EMPTY, label: 'תפוסים בלבד' },
    { value: OCCUPANCY.ONLY_EMPTY, label: 'ריקים בלבד' },
    { value: OCCUPANCY.WAITING_LOCATION, label: 'ממתינים לאיתור' },
];

interface Props {
    value: OccupancyValue;
    onSelect: (value: OccupancyValue) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    leadingIcon?: React.ReactNode | null;
    className?: string;
}

const OccupancySelector: React.FC<Props> = ({
    value,
    onSelect,
    placeholder,
    disabled,
    readOnly,
    leadingIcon,
    className,
}) => (
    <OptionSelect
        options={OCCUPANCY_OPTIONS}
        value={OCCUPANCY_OPTIONS.find((o) => o.value === value) ?? null}
        onSelect={(o) => onSelect((o?.value ?? OCCUPANCY.ALL) as OccupancyValue)}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        leadingIcon={leadingIcon === undefined ? <BoxesIcon /> : leadingIcon}
        className={className}
    />
);

export default OccupancySelector;
